<template>
  <v-container fluid>
    <div v-if="loader">
      <v-skeleton-loader
        transition-group="fade-transition"
        type="table-tfoot, list-item-two-line, image"
      ></v-skeleton-loader>
    </div>
    <div class="tree" v-else>
      <v-container>
        <v-row align="center">
          <div style="display: flex; justify-items: start">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  elevation="0"
                  class="ml-2"
                  @click="openAllFCT()"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon class="rotateBTN" :class="{ rotate: openAll }">
                    mdi-menu-right
                  </v-icon>
                </v-btn>
              </template>
              <span>
                {{
                  this.openAll
                    ? $t("component.closeAll")
                    : $t("component.openAll")
                }}
              </span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon elevation="0" class="mr-3" v-bind="attrs" v-on="on">
                  <v-icon v-if="selectionEmpty" @click="selectAll()">
                    mdi-checkbox-blank-outline
                  </v-icon>
                  <v-icon v-if="selectionPartial" @click="selectAll()">
                    mdi-minus-box-outline
                  </v-icon>
                  <v-icon v-if="selectionFull" @click="selectEmpty()">
                    mdi-checkbox-outline
                  </v-icon>
                </v-btn>
              </template>
              <span>
                {{
                  this.selectionFull
                    ? $t("component.deselectAll")
                    : $t("component.selectAll")
                }}
              </span>
            </v-tooltip>
          </div>
          <v-text-field
            v-model="search"
            class="mr-2 mb-2"
            :label="$t('fav.searchRule')"
            outlined
            clearable
            hide-details
            clear-icon="mdi-close-circle-outline"
          ></v-text-field>
        </v-row>
      </v-container>
      <v-treeview
        :items="items"
        selectable
        selected-color="primary"
        open-on-click
        v-model="selection"
        :search="search"
        :open.sync="open"
      >
        <template slot="label" slot-scope="{ item }">
          <v-row class="mx-2 my-2" align="center" style="height: 40px">
            <app-flag :from="item.origin"></app-flag>
            <p class="text-body-1" style="margin: 0">{{ item.name }}</p>
            <v-spacer></v-spacer>
            <p v-if="item.children" class="text-body-1" style="margin: 0">
              ({{ sumObject(item.children) }} {{ $t("generic.of") }}
              {{ item.totalRules }})
            </p>
          </v-row>
        </template>
      </v-treeview>
    </div>
  </v-container>
</template>

<style>
/* refonte du composant via pure css */
.tree > .v-treeview > .v-treeview-node {
  border: 1px solid #ca0538;
  border-radius: 4px;
  margin: 5px;
}
.tree > .v-treeview > .v-treeview-node > .v-treeview-node__root {
  background-color: #ca0538;
  color: white;
}
.tree > .v-treeview > .v-treeview-node > .v-treeview-node__root > button {
  color: white;
}
.tree
  > .v-treeview
  > .v-treeview-node
  > .v-treeview-node__root
  > button::before {
  color: white;
}
.rotateBTN {
  transition: transform 0.3s ease-in-out !important;
}

.rotateBTN.rotate {
  transform: rotate(90deg);
}
</style>

<script>
import { mapGetters, mapMutations } from "vuex";
import AppFlag from "./AppFlag.vue";

export default {
  data() {
    return {
      search: null,
      items: [],
      loader: true,
      selection: [],
      selectCounter: {
        air: {
          "626a91f2ff24508dc5a8f84d": 1,
        },
      },
      defaultFav: [],
      allRulesIds: [],
      selectionEmpty: true,
      selectionPartial: false,
      selectionFull: false,
      openAll: false,
      open: [],
    };
  },
  computed: {
    ...mapGetters([
      "current_rules_fav",
      "need_save_rules",
      "importDefaultRulesFav",
      "rules_fav",
      "multiRulesSelection",
      "identity",
    ]),
    label_value() {
      if (this.type === "fav") {
        return this.$t("fav.searchRule");
      }
      return this.$t("fav.searchRule");
    },
  },
  components: {
    AppFlag,
  },
  props: {
    type: String,
  },
  methods: {
    ...mapMutations([
      "setLastPage",
      "setMultiRulesSelection",
      "setimportDefaultRulesFav",
    ]),
    async fetchRulesByThemes() {
      var request = {
        method: "GET",
        url: "/rulesbytheme",
      };
      try {
        var response = await this.axios(request);
        if (!this.items.length) {
          this.loader = true;
        }
        this.items = response.data;
        if (this.items.length) {
          this.loader = false;
        }
        // save all Rules ID :
        this.items.forEach((theme) => {
          theme.children.forEach((rule) => {
            if (this.allRulesIds.indexOf(rule.id) < 0) {
              this.allRulesIds.push(rule.id);
            }
          });
        });
        // affectation des valeurs :
        if (this.type === "fav") {
          // affecte les actives en fonction du cas
          if (this.need_save_rules) {
            this.selection = this.current_rules_fav;
          } else {
            this.selection = this.rules_fav;
          }
        } else if (this.type === "multiRules") {
          this.selection = this.multiRulesSelection;
        }
      } catch (err) {
        console.log(err);
      }
    },
    sumObject(rulesArray) {
      let sum = 0;
      rulesArray.forEach((rule) => {
        if (this.selection.indexOf(rule.id) >= 0) {
          sum = sum + 1;
        }
      });
      return sum;
    },
    need_save(array) {
      let need_save = false;
      array.forEach((value) => {
        if (this.rules_fav.indexOf(value) < 0) {
          need_save = true;
        }
      });
      this.rules_fav.forEach((fav) => {
        if (array.indexOf(fav) < 0) {
          need_save = true;
        }
      });
      this.$store.commit("setNeedSaveRules", need_save);
    },
    importPossible(array) {
      let importPossible = false;
      array.forEach((value) => {
        if (this.defaultFav.indexOf(value) < 0) {
          importPossible = true;
        }
      });
      this.defaultFav.forEach((fav) => {
        if (array.indexOf(fav) < 0) {
          importPossible = true;
        }
      });
      this.setimportDefaultRulesFav(importPossible);
    },
    async fetchDefaultFav() {
      // console.log("GO TAKE FAV !!!!");
      try {
        // search user
        let url = "defaultrulesfav?company=" + this.identity.company;
        url = encodeURI(url);
        // console.log(url);
        const headers = {
          "content-type": "application/json",
        };
        const response = await this.axios.get(url, headers);
        this.defaultFav = response.data;
        this.importPossible(this.selection);
      } catch (err) {
        console.log(`err`, err);
        console.error(err);
      }
    },
    selectAll() {
      this.selection = this.allRulesIds;
    },
    selectEmpty() {
      this.selection = [];
    },
    openAllFCT() {
      this.openAll = !this.openAll;
      this.$children[3].updateAll(this.openAll);
    },
  },
  beforeMount() {
    this.fetchRulesByThemes();
    if (this.type === "fav") {
      this.fetchDefaultFav();
    }
  },
  watch: {
    search(value) {
      // OPEN PANEL WHEN SEARCH
      if (value === null || !value.length) {
        this.openAll = true;
      } else {
        this.openAll = false;
      }
      this.openAllFCT();
    },

    selection(value) {
      if (this.type === "fav") {
        this.$store.commit("setCurrentRulesFav", value);
        this.need_save(value);
        this.importPossible(value);
      } else if (this.type === "multiRules") {
        this.setMultiRulesSelection(value);
      }
      this.selectionEmpty = false;
      this.selectionPartial = false;
      this.selectionFull = false;
      if (value.length === this.allRulesIds.length) {
        this.selectionFull = true;
      } else if (value.length > 0) {
        this.selectionPartial = true;
      } else {
        this.selectionEmpty = true;
      }
    },
    open(value) {
      if (value.length > 0) {
        this.openAll = true;
      } else {
        this.openAll = false;
      }
    },
  },
};
</script>